import CC from "CookieConsent";

export default function () {
    var container = document.getElementById("cc-container");
    var ccpage = document.getElementById("cc-page");
    //var sz = document.getElementsByTagName("script")[0];

    var url = container != null && container.dataset != null && container.dataset.ccurl != null
        ? container.dataset.ccurl : "";

    window.cookieconsent.initialise({
        "container": container,
        "type": "opt-out",
        "content": {
            "message": "På Eidar.se använder vi cookies/kakor. Det är små textfiler som skapas och lagras på den enhet du använder för att besöka vår webbplats, till exempel en dator eller mobiltelefon. Vi använder detta för att förbättra innehållet på vår webbplats och samla in statistik. Ditt godkännande sparas under ett år. Du kan själv kontrollera vilka kakor som får placeras i din webbläsare.",
            "allow": "Godkänn",
            "deny": "Neka",
            "link": "Läs mer här.",
            "href": url,
            "policy": ""
        },
        "static": true,
        "revokable": false,
        "animateRevokable": false,
        onStatusChange: function (status) {
            ccpage.remove();
            var type = this.options.type;
            var didConsent = this.hasConsented();

            if (type == 'opt-out' && !didConsent) {
                // disable cookies
                disableAllCookies();
            }
            else if (type == 'opt-in' && didConsent) {
                // enable cookies
                activateSiteImprove();
            }
        },
        onRevokeChoice: function () {
            var type = this.options.type;
            if (type == 'opt-in') {
                // disable cookies
                disableAllCookies();
            }
            if (type == 'opt-out') {
                // enable cookies
                activateSiteImprove();
            }
        },
        onPopupOpen: function () {
            ccpage.classList.add("cc-page");
            if (this.options.type == 'opt-out') {
                activateSiteImprove();
            }
        },
        onPopupClose: function () {
            ccpage.classList.remove("cc-page");
        },
        onInitialise: function (status) {
            if (this.options.type == 'opt-out' && this.hasConsented()) {
                activateSiteImprove();
            }
        },
    });
}

function activateSiteImprove() {
    var sz = document.createElement("script");
    sz.type = "text/javascript";
    sz.async = true;
    sz.src = "//siteimproveanalytics.com/js/siteanalyze_8055.js";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(sz, s);
}

function disableSiteImprove() {
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        var name = c.split('=')[0];
        var id = c.split('=')[1];
        if (name == "nmstat" || name == "AWSELB" || name == "AWSELBCOR") {
            eraseCookie(name, id);
        }
    }
}

function disableAllCookies() {
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        var name = c.split('=')[0];
        var id = c.split('=')[1];
        if (name != "cookieconsent_status") {
            eraseCookie(name, id);
        }
    }
}

function eraseCookie(name, id) {
    setCookie(name, id, -1);
}

function setCookie(name, id, days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
    }
    else {
        var expires = "";
    }

    document.cookie = name + "=" + id + expires + "; path=/";
}
